import ConnectedIcon from 'assets/ConnectedIcon';
import { useIntl } from 'react-intl';

import OEMTelematicsTable from './components/Table.component';

import colors from 'styles/colors';
import { SectionHeader, SectionContent, SectionHeaderTitle } from 'styles/cards';
import { TelematicsSection } from '../styles';

import { PropsOf } from 'utils/types.utils';
import UnenrollmentModalProvider from './components/Unenrollment.context';
import { DataSources } from 'services/resources';

type TelematicsCardProps = PropsOf<typeof TelematicsSection> & {
  dataSources: DataSources;
  dataSourcesLoading: boolean;
  onlyDataSourceIsZubieOEM: boolean;
};

const TelematicsCard = ({
  dataSources,
  dataSourcesLoading,
  onlyDataSourceIsZubieOEM,
  ...styleProps
}: TelematicsCardProps) => {
  const intl = useIntl();

  return (
    <TelematicsSection {...styleProps}>
      <SectionHeader>
        <SectionHeaderTitle>
          <ConnectedIcon color={colors.blue} />
          {intl.formatMessage({
            id: 'views.FleetSettings.OEMTelematics.title',
          })}
        </SectionHeaderTitle>
      </SectionHeader>
      <SectionContent>
        <UnenrollmentModalProvider>
          <OEMTelematicsTable
            dataSources={dataSources}
            dataSourcesLoading={dataSourcesLoading}
            onlyDataSourceIsZubieOEM={onlyDataSourceIsZubieOEM}
          />
        </UnenrollmentModalProvider>
      </SectionContent>
    </TelematicsSection>
  );
};

export default TelematicsCard;
